import React from 'react';
import Img, {CloudimageProvider} from 'react-cloudimage-responsive';

/* Components */
import PriceFormat from '../../common/PriceFormat';
import ProductSticker from "../../product-sticker/components/ProductSticker";
import placeholderUrl from "../../../../../app/img/placeholders/product-placeholder.png"

/* Helpers */
import {cloudImageConfig} from '../../../cloudimage';
import {resolveLocalizedSticker} from '../../helpers/resolveLocalizedSticker';

export default function SearchVehicleCard({
   vehicle,
   stickerTooltips,
}) {


    const {image_url, image, price, private_finance, business_finance, url, slug, brand, model, type, enrichedValues, action_price} = vehicle;
    const vehicleUrl = url || slug;
    const vehicleImageSource = image_url || image;

    let vehicleImageUrl = placeholderUrl;
    let vehicleImageDescription = window.Translator.trans('app.header.search.vehicle_card.image_placeholder');

    if (vehicleImageSource) {
        vehicleImageUrl = vehicleImageSource;
        vehicleImageDescription = brand + ' ' + model;
    }

    const localizedSticker = resolveLocalizedSticker(enrichedValues, document.body.dataset.countryLanguage);

    const buyLabel = window.Translator.trans('webstores_voertuigen_voorraad.overview.buy_label');

    const renderPriceSection = (label, value, prefixValue, action_price, isBuy = false) => (
        <div className="col-12">
            <div className="row gutters-2 justify-content-between align-items-center">
                <div className="col-auto">
                    <p className="text--12">{label}</p>
                </div>
                <div className="col-auto">
                    {isBuy && action_price && action_price > 0 && action_price < value ? (
                        <div className="d-flex gap-2 flex-row">
                            <PriceFormat className="font-weight-bold text--12 text-muted--60" tag="del" value={parseFloat(value)} />
                            <PriceFormat className="font-weight-bold text--12" tag="p" value={parseFloat(action_price)} />
                        </div>
                     ) : (
                        <PriceFormat className="font-weight-bold text--12" tag="p" value={parseFloat(value)} />
                    )}
                </div>
            </div>
        </div>
    );

    return (
        <a
            className={`card card--product card--white h-100`}
            href={vehicleUrl}
            title={`${brand} ${model} ${type}`}
            target={'_self'}
            >
            <div className="card__header">
                {localizedSticker?.hidden !== true &&
                    <ProductSticker
                        sticker={localizedSticker}
                        stickerTooltips={stickerTooltips}
                    />
                }

                <CloudimageProvider config={{...cloudImageConfig, params: 'org_if_sml=1&w=420&h=280'}}>
                    <Img className="card__image" src={vehicleImageUrl} alt={vehicleImageDescription} ratio={1.5} width="420px" height="280px" />
                </CloudimageProvider>

                <div className="card__badge badge badge-primary">{enrichedValues?.reserved  ? window.Translator.trans('app.header.search.vehicle_card.sold') : ""}</div>
            </div>
            <div className="card-body d-flex flex-column position-relative">
                <div>
                    <div>
                        <p className="h6 mb-2 card__title">
                            {brand} {model}
                        </p>
                        <p className="text-muted--50 mb-2 line-clamp line-clamp-2 card__type">{type}</p>
                    </div>

                    <div className="row gutters-2 p-1 pt-3">
                        <div className="card__prices w-100">
                            <div className="row row--horizontal-bordered gutters-2">
                                {price && price > 0 && renderPriceSection(buyLabel, price, null, action_price, true)}
                                {private_finance && private_finance > 0 && renderPriceSection(window.Translator.trans('webstores_voertuigen_voorraad.overview.finance_private_label'), private_finance, 'p.m')}
                                {business_finance && business_finance > 0 && renderPriceSection(window.Translator.trans('webstores_voertuigen_voorraad.overview.finance_business_label'), business_finance, 'p.m')}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </a>
    );
}
